import React from 'react'
import { Outlet } from 'react-router-dom'

const ProjectDeptCountMngPage = () => {
    return (
        <div>
            <Outlet />
        </div>
    )
}

export default ProjectDeptCountMngPage